<template>
  <div class="fill-height" >
    <Progress
      key="default-loading"
      :show="loading"
    />
    <slot v-if="!loading"></slot>
  </div>
</template>

<script>
import Progress from './Progress'

export default {
  name: 'Spinner',

  components: {
    Progress
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
